import React from "react";

import Box from "@mui/joy/Box";
import {Stack} from "@mui/joy";

// components
import ComponentCard from "../Common/ComponentCard";
import Divider from "@mui/joy/Divider";


class SearchResults extends React.Component {
    renderItem(item){
        return (
            <ComponentCard
                entity={item.model}
                entity_id={item.id}
                showTitle={true}
            />
        )
    }

    render() {
        return (
            <Box
                sx={{
                    overflowY: 'scroll',
                    width: 'calc(80vw)',
                    pr: 2,
                    pt: 2,
                }}
            >
                <Stack
                    spacing={2}
                >
                    <Divider />
                    {this.props.results.map(each => {
                        return(
                            <>
                                {this.renderItem(each)}
                                <Divider />
                            </>
                        )
                    })}
                </Stack>
            </Box>
        )
    }
}

export default SearchResults